module.exports = __webpack_public_path__ + "img/index08.c66bdf3a.jpg";